export function About() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 pb-4 mt-[34px]">
      <h2 className="text-2xl font-bold mb-4">About Page</h2>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 max-w-[70vw]">
        <h2 className="text-2xl font-bold mb-4">Did you know?</h2>

        <p className="mb-4">
          PWAs have access to many useful APIs in modern browsers! These APIs
          have enabled many new types of apps that can be built as PWAs, such as
          advanced graphics editing apps, games, apps that use machine learning
          and more!
        </p>

        <p>
          Check out{' '}
          <a
            href="https://docs.microsoft.com/en-us/microsoft-edge/progressive-web-apps-chromium/how-to/handle-files"
            className="text-blue-600 dark:text-blue-400 hover:underline"
          >
            these docs
          </a>{' '}
          to learn more about the advanced features that you can use in your PWA
        </p>
      </div>
    </div>
  );
}
